import { ReactNode } from "react";
import styles from "./DialogContent.module.scss";

export type DialogSize = "small" | "medium" | "full-screen";

type DialogOverlayProps = {
  size?: DialogSize;
  onDismiss?: () => void;
  children: ReactNode;
};

export const DialogOverlay = ({
  size = "small",
  onDismiss,
  children,
}: DialogOverlayProps) => {
  return (
    <div
      className={`modal modal__centered modal_${size} ${styles.modal}`}
      onClick={onDismiss}
    >
      {children}
    </div>
  );
};
